import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { autoLogin, logOut } from "../redux/authentication/actionCreator";
import { message } from "antd";
import Spinner from "../components/utilities/Spinner";

const AutoLogin = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAutoLogin = async () => {
      try {
        if (!token) {
          navigate("/login", { replace: true });
          return;
        }

        await dispatch(logOut());
        const result = await dispatch(autoLogin(token));

        if (result?.status) {
          message.success("Auto login successful");
          navigate(result.redirectUrl || "/dashboard", { replace: true });
        } else {
          message.error(result?.message || "Auto login failed");
          navigate("/login", { replace: true });
        }
      } catch (error) {
        message.error("Auto login failed");
        navigate("/login", { replace: true });
      }
    };

    handleAutoLogin();
  }, [token, dispatch, navigate]);

  return <Spinner />;
};

export default AutoLogin;
